import { AHText, Box, TouchableBox, useLayoutContext } from "arkh";
import React, { PropsWithChildren, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { WidgetSizeT } from "../localTypes/WidgetSizeT";
import { WAPreviewContainer } from "./WAPreviewContainer";
import { Pressable } from "react-native";

type Props = PropsWithChildren<{
  title: React.ReactNode;
  description?: React.ReactNode;
  unitSize: number;
  size: WidgetSizeT;
  hasSizeWithinBounds: boolean;
  onAdd?(): void;
  addTitle?: string;
  overflow?: "hidden" | "visible";
}>;

export function WACategoryWidgetContainer(props: Props) {
  const displayScale = useMemo(
    () => (props.size.h === 4 ? 0.5 : props.size.h === 3 ? 2 / 3 : 1),
    [props.size.h]
  );
  const layout = useLayoutContext();
  return (
    <Box spaceBottom="large" style={{ alignSelf: "stretch" }}>
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        <AHText type="title-small" style={{ flex: 1 }} numberOfLines={2}>
          {props.title}
        </AHText>
        {!props.hasSizeWithinBounds ? (
          <Box spaceLeft="medium">
            <Box
              color="primary"
              style={{
                opacity: 0.3,
                height: layout.circle.medium,
                justifyContent: "center",
                paddingHorizontal: layout.space.medium,
                borderRadius: layout.circle.medium / 2,
              }}
            >
              <AHText type="title-small" color="text-inverted">
                <FormattedMessage
                  description="WidgetAdd not enough space label"
                  defaultMessage="Not enough space"
                />
              </AHText>
            </Box>
          </Box>
        ) : props.onAdd ? (
          <Box spaceLeft="medium">
            <TouchableBox
              color="primary"
              style={{
                height: layout.circle.medium,
                justifyContent: "center",
                paddingHorizontal: layout.space.medium,
                borderRadius: layout.circle.medium / 2,
              }}
              onPress={props.onAdd}
            >
              <AHText type="title-small" color="text-inverted">
                {props.addTitle ?? (
                  <FormattedMessage
                    description="WidgetAdd default select widget button label"
                    defaultMessage="Select"
                  />
                )}
              </AHText>
            </TouchableBox>
          </Box>
        ) : null}
      </Box>
      {props.description ? (
        <AHText
          type="body"
          spaceTop="medium"
          color="darkText"
          style={{ lineHeight: 17, fontSize: 13 }}
        >
          {props.description}
        </AHText>
      ) : null}
      <Box spaceTop="large" />
      <Pressable
        onPress={props.onAdd}
        disabled={!props.hasSizeWithinBounds || !props.onAdd}
      >
        <WAPreviewContainer
          h={props.size.h}
          w={props.size.w}
          scale={displayScale}
          unitSize={props.unitSize}
          overflow={props.overflow}
        >
          {props.children}
        </WAPreviewContainer>
      </Pressable>
    </Box>
  );
}
